export default __webpack_public_path__ + "neighborhood.png?fd2412568ba94b07a48bba8c1c5f7ac3";